import { fabric } from 'fabric';

import { InternalCanvas } from '../canvas';
import { DrawingTool, ObjectBuilder, UpdateObjectRect } from './tool';

class TextboxBuilder extends ObjectBuilder<fabric.Textbox> {
    public constructor(canvas: InternalCanvas, initialPoint: fabric.Point) {
        super(
            initialPoint,
            new fabric.Textbox('', {
                left: initialPoint.x,
                top: initialPoint.y,
                fontFamily: 'Arial',
                editable: true,
                fill: canvas.brushColor,
            }),
        );
        this._object.setControlsVisibility({ mt: false, mb: false });
    }

    protected _updateObject({ left, top, width }: UpdateObjectRect): void {
        this._object.set({ left, top, width });
    }

    protected _finalizeObject(): fabric.Textbox | void {
        if (!this._object.width || !this._object.height) {
            return;
        }

        this._object.set({ editable: true });

        return this._object;
    }
}

export class TextboxTool extends DrawingTool {
    public createObjectBuilder(
        canvas: InternalCanvas,
        initialPoint: fabric.Point,
    ): TextboxBuilder {
        return new TextboxBuilder(canvas, initialPoint);
    }
}
